<mat-card>
  <h2 translate>sidenav.menu.certifiedPayment</h2>

  <mat-card-content>
    <form [formGroup]="searchPaymentCert" (ngSubmit)="onSearchClick()">
      <div fxFlex fxLayout="row wrap" class="form-wrapper">
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="!isExternalCommercial">
          <scf-custom-select-search
            #chain
            [id]="'chain'"
            formControlName="chain"
            fxFlex="100"
            [dataInput]="chainsList"
            [placeholder]="'monthlyReport.selectChain'"
            [isMultiple]="false"
            [showErrors]="searchPaymentCert?.controls?.chainsList?.errors"
            (selectionChange)="onChainSelection($event)"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50" *ngIf="!isExternalCommercial">
          <scf-custom-select-search
            #prescriptor
            [id]="'prescriptor'"
            formControlName="prescriptor"
            fxFlex="100"
            [dataInput]="prescriptorsList"
            [placeholder]="'tracingReports.selectPrescriptor'"
            [isMultiple]="false"
            [isRequired]="true"
            [showErrors]="searchPaymentCert?.controls?.prescriptor?.errors"
            (selectionChange)="onPrescriberSelection($event)"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="50">
          <scf-custom-select-search
            [id]="'establishment'"
            formControlName="establishment"
            fxFlex="100"
            [dataInput]="establishmentsList"
            [placeholder]="'tracingReports.selectEstablishment'"
            [isRequired]="true"
            [isMultiple]="false"
            [showErrors]="searchPaymentCert?.controls?.establishment?.errors"
            (selectionChange)="onEstablishmentSelection($event)"
          >
          </scf-custom-select-search>
        </div>
        <div fxFlex="60" fxFlex.gt-sm="25">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>paymentCert.contract</mat-label>
            <input
              id="contractId"
              matInput
              #numberContract
              formControlName="numberContract"
              type="text"
              maxlength="12"
              (keypress)="numberOnly($event, numberContract)"
              (paste)="numberOnly($event, numberContract)"
              (blur)="isOptional()"
              (keypress)="isOptional()"
              autocomplete="off"
            />
            <mat-hint *ngIf="isNumberContractOptional" translate>Opcional</mat-hint>
            <mat-error *ngIf="searchPaymentCert.controls.numberContract.errors?.required" translate>
              field.required
            </mat-error>
            <mat-error *ngIf="searchPaymentCert.controls.numberContract.errors?.numContractInvalid" translate>
              paymentCert.invalidContract
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="60" fxFlex.gt-sm="25">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>paymentCert.sol</mat-label>
            <input
              id="operationId"
              matInput
              #operation
              formControlName="operation"
              type="text"
              maxlength="15"
              (keypress)="numberOnly($event, operation)"
              (paste)="numberOnly($event, operation)"
              (blur)="isOptional()"
              (keypress)="isOptional()"
              autocomplete="off"
            />
            <mat-hint *ngIf="isOperationOptional" translate>Opcional</mat-hint>
            <mat-error *ngIf="searchPaymentCert.controls.operation.errors?.required" translate>
              field.required
            </mat-error>
            <mat-error *ngIf="searchPaymentCert.controls.operation.errors?.numSolInvalid" translate>
              paymentCert.invalidSol
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="99">
          <div fxFlexAlign="start" fxLayoutAlign="end">
            <button
              id="searchTracingReports"
              mat-flat-button
              type="submit"
              color="accent"
              [disabled]="searchPaymentCert.invalid"
            >
              <span>{{ 'tracingReports.consult' | translate | uppercase }}</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="reports">
  <!-- HEADER -->
  <div
    class="panel-request__card-header"
    *ngIf="reports && reports.length > 0"
    fxLayout="row wrap"
    fxLayoutAlign="space-between center"
  >
    <h2 class="panel-request__card-header--title" translate>paymentReports.results</h2>
    <div fxFlex fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.gt-xs="end center" fxLayoutGap="16px">
      <button id="createExcelPanel" mat-stroked-button color="accent" (click)="createExcel()">
        <mat-icon class="icon-ic_file_download"></mat-icon>
        <span>{{ 'button.exportExcel' | translate | uppercase }}</span>
      </button>
      <button id="createPdfPanel" mat-stroked-button color="accent" (click)="createPdf()">
        <mat-icon class="icon-ic_print"></mat-icon>
        <span>{{ 'button.print' | translate | uppercase }}</span>
      </button>
    </div>
  </div>

  <!-- CONTENT -->
  <mat-card-content>
    <div *ngIf="reports && dataSource.data?.length > 0; else noOperations" class="table__wrapper">
      <!-- TABLE -->
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef translate>paymentCert.date</th>
          <td mat-cell *matCellDef="let element">{{ element.date }}</td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef translate>paymentCert.amount</th>
          <td mat-cell *matCellDef="let element">{{ element.amount }}</td>
        </ng-container>
        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef translate>paymentCert.state</th>
          <td mat-cell *matCellDef="let element">{{ element.state }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <ng-template #noOperations>
      <div fxLayout="column" fxLayoutAlign="center center" class="invest-detail__card">
        <mat-label class="panel-request__label-no-operation" translate>investDetail.noOperations</mat-label>
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>
